module.exports = __webpack_public_path__ + "media/images/flags/4x3/ncl-5fd61bc5535ea1e6945a78f4f99e0ee2.svg";